import React, { useEffect } from 'react';
import { isURL } from 'validator';
import Employee from './Employee';
import Loader from "../Loader";
import { createDataTestId, AutomationTestIdFeature, AutomationTestIdElementType } from '../../utilities/automation';

export default function EmployeeGrid({ employees, virtualEmployees, isLoading, isSearch, radius, address, errorMessage, cardClass, cardButtonClass }) {
    const hasEmployees = employees.length > 0;
    const renderEmployees = !hasEmployees && isSearch ? virtualEmployees : employees;

    function showError() {
        if (isSearch && !hasEmployees) {
            const message = errorMessage.replace(/{{radius}}/ig, `${radius} miles`).replace(/{{address}}/ig, address);
            return (
                <div className="text-center text-primary py-4">
                    {message.split(/\\n/g).map((d,index) => <div key={index}><strong style={{whiteSpace: 'pre-line'}}>{d.trim()}</strong></div>)}
                </div>);
        }
    }

    useEffect(() => {
        const scriptId = "onceHubScript";
        const loadOnceHubScript = renderEmployees.some((employee) => employee.custom_two && !isURL(employee.custom_two));

        document.getElementById(scriptId)?.remove();
        if (!isLoading && loadOnceHubScript) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = "https://cdn.oncehub.com/mergedjs/so.js";
            document.body.appendChild(script);
        }
    }, [isLoading]);

    return (
        <div className="position-relative" style={{minHeight: '100px'}}>
            <Loader spinner={isLoading} top={10} width={4} height={4} variant="secondary" />
            {showError()}
            {!isLoading && <div className="row h-100 py-4" data-test-id={createDataTestId({feature: AutomationTestIdFeature.EMPLOYEE_LOOKUP, element: AutomationTestIdElementType.COLLECTION})}>
                {renderEmployees.map(employee => <Employee key={employee.CodeName || employee.codeName} cardClass={cardClass} cardButtonClass={cardButtonClass} {...employee} />)}
            </div>}
        </div>
    );
}
